/* eslint-disable */
import Component from 'gia/Component'
import select2 from 'select2'

export default class ComponentHeader extends Component {
  constructor(element) {
    super(element)
  }

  // switch() {
  //   const selector = $(this.element).find('select#type')
  //   const defaultFilter = $(this.element).find('.filter-wrapper.default')
  //   const AllFilters = $(this.element).find('.filter-wrapper')

  //   const filterInputs = $(this.element).find(
  //     '.switch-up input[type="checkbox"]'
  //   )

  //   function theFilters(val) {
  //     const myFilters = $(`.filter-wrapper[data-filter="${val}"]`)

  //     AllFilters.hide()
  //     myFilters.show()

  //     if (!val) {
  //       defaultFilter.show()
  //     }
  //   }

  //   selector.change(function() {
  //     filterInputs.prop('checked', false)
  //     const state = $(this).val()

  //     theFilters(state)
  //   })

  //   theFilters(selector.val())
  // }

  // new switch function to accommodate FacetWP filter plugin
  switch() {
    const selector = $(this.element).find('select#type')
    const defaultFilter = $(this.element).find('.filter-wrapper.default')
    const AllFilters = $(`.facetwp-filter-wrapper`)
    const actions = $(`.action-btns`)

    function theFilters(val) {
      const filterTrigger = $(`.trigger`)
      const advanceFilter = $(`.facetwp-filter-wrapper[data-filter="${val}"]`)
      if (!val) {
        defaultFilter.show()
        filterTrigger.hide()
        actions.hide()
      } else {
        advanceFilter.toggleClass('active')
        filterTrigger.show()
        actions.show()
        defaultFilter.hide()
      }
    }

    function setCookie(cname, cvalue, exdays) {
      var d = new Date()
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
      var expires = 'expires=' + d.toUTCString()
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
    }

    selector.change(function() {
      AllFilters.removeClass('active')
      const state = $(this).val()

      if ($('body.home').length) {
        setCookie('type', state, 1)
      }

      theFilters(state)
    })

    theFilters(selector.val())
  }

  getCookie(cname) {
    var name = cname + '='
    var ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i]
      while (c.charAt(0) == ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ''
  }

  mount() {
    const that = this
    $(document).on('facetwp-loaded', function() {
      const type = that.getCookie('type')
      if (type && $('body.home').length === 0) {
        $('#type').val(type)
        $('#type').trigger('change')
        $('.drop-trigger').trigger('click')
        document.cookie =
          'type=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
      }
    })

    this.switch()
  }
}



// WEBPACK FOOTER //
// ./scripts/components/FilterSwitch.js